import { useEffect, useState } from 'react';
import { api } from '../lib/api';

type Kullanici = { id: number; name: string };

export default function YeniCari({ kapat, eklendi }: { kapat: () => void; eklendi: () => void }) {
  const [name, setName] = useState('');
  const [type, setType] = useState('PERAKENDE');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [city, setCity] = useState('');
  const [segment, setSegment] = useState('');
  const [ownerId, setOwnerId] = useState('');
  const [kullanicilar, setKullanicilar] = useState<Kullanici[]>([]);
  const [hata, setHata] = useState<string | null>(null);
  const [bekliyor, setBekliyor] = useState(false);

  useEffect(() => {
    api<{ kullanicilar: Kullanici[] }>('/api/kullanicilar')
      .then((r) => setKullanicilar(r.kullanicilar)).catch(() => undefined);
  }, []);

  async function gonder(e: React.FormEvent) {
    e.preventDefault();
    setHata(null); setBekliyor(true);
    try {
      await api('/api/crm/cari', {
        method: 'POST',
        body: JSON.stringify({
          name, type,
          phone: phone || undefined, email: email || undefined, city: city || undefined,
          segment: segment || undefined,
          ownerId: ownerId ? Number(ownerId) : undefined,
        }),
      });
      eklendi();
    } catch (err) {
      setHata(err instanceof Error ? err.message : 'Kaydedilemedi');
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <div className="ccd-drawer-arka" onClick={kapat} role="presentation">
      <aside className="ccd-drawer" onClick={(e) => e.stopPropagation()}
             role="dialog" aria-modal="true" aria-label="Yeni cari">
        <form className="ccd-stack" onSubmit={gonder}>
          <div className="ccd-row-between">
            <div>
              <div className="ccd-eyebrow">CRM</div>
              <h2 className="ccd-heading">Yeni cari</h2>
            </div>
            <button type="button" className="ccd-btn ccd-btn-ghost ccd-btn-sm" onClick={kapat}>Kapat</button>
          </div>

          <div className="ccd-field">
            <label className="ccd-field-label" htmlFor="cad2">
              Cari adı<span className="ccd-required"> *</span>
            </label>
            <input id="cad2" className="ccd-input" required autoFocus value={name}
                   onChange={(e) => setName(e.target.value)} />
          </div>

          <div className="ccd-form-grid">
            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="ctip">Tür</label>
              <select id="ctip" className="ccd-select" value={type} onChange={(e) => setType(e.target.value)}>
                <option value="BAYI">Bayi</option>
                <option value="MIMAR">Mimar</option>
                <option value="PROJE">Proje</option>
                <option value="PERAKENDE">Perakende</option>
                <option value="FASONCU">Fasoncu</option>
              </select>
            </div>
            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="cseg">Segment</label>
              <select id="cseg" className="ccd-select" value={segment} onChange={(e) => setSegment(e.target.value)}>
                <option value="">—</option>
                <option value="A">A</option><option value="B">B</option><option value="C">C</option>
              </select>
              <div className="ccd-field-hint">Elle girilir; otomatik segmentasyon yok.</div>
            </div>
          </div>

          <div className="ccd-form-grid">
            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="ctel2">Telefon</label>
              <input id="ctel2" className="ccd-input" type="tel" inputMode="tel" autoComplete="tel" placeholder="+90 5xx…" value={phone}
                     onChange={(e) => setPhone(e.target.value)} />
            </div>
            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="ceps">E-posta</label>
              <input id="ceps" className="ccd-input" type="email" inputMode="email" autoComplete="email" autoCapitalize="none" value={email}
                     onChange={(e) => setEmail(e.target.value)} />
            </div>
          </div>

          <div className="ccd-form-grid">
            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="csehir">Şehir</label>
              <input id="csehir" className="ccd-input" value={city} onChange={(e) => setCity(e.target.value)} />
            </div>
            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="csor">Sorumlu</label>
              <select id="csor" className="ccd-select" value={ownerId}
                      onChange={(e) => setOwnerId(e.target.value)}>
                <option value="">—</option>
                {kullanicilar.map((k) => <option key={k.id} value={k.id}>{k.name}</option>)}
              </select>
            </div>
          </div>

          {hata && (
            <div className="ccd-banner ccd-banner-danger">
              <span className="ccd-banner-icon">!</span><span>{hata}</span>
            </div>
          )}

          <button className="ccd-btn ccd-btn-primary ccd-btn-lg" disabled={bekliyor}>
            {bekliyor ? 'Kaydediliyor…' : 'Cariyi kaydet'}
          </button>
        </form>
      </aside>
    </div>
  );
}
